import {
  CLEAN_OAUTH_APPLICATIONS,
  DELETE_OAUTH_APPLICATION,
  ERROR,
  GET_OAUTH_APPLICATION,
  LIST_OAUTH_APPLICATIONS,
  SAVE_OAUTH_APPLICATION,
  SET_RELOAD_OAUTH_APPLICATIONS,
  START,
  SUCCESS
} from '../actions/types';
import { getError } from '../../utils/requestUtils';

const INITIAL_STATE = {
  oauthApplications: [],
  oauthApplication: null,
  pagination: null,
  reloadOauthApplications: false,

  listOauthApplications: {},
  getOauthApplication: {},
  saveOauthApplication: {},
  deleteOauthApplication: {}
};

export default function reducer(state = INITIAL_STATE, action) {
  const data = action.payload?.data;
  const error = getError(action.payload);

  switch (action.type) {
    case LIST_OAUTH_APPLICATIONS + START:
      return { ...state, listOauthApplications: { loading: true } };
    case LIST_OAUTH_APPLICATIONS + SUCCESS:
      return {
        ...state,
        listOauthApplications: { loading: false },
        oauthApplications: data.result.items,
        pagination: data.result.pagination
      };
    case LIST_OAUTH_APPLICATIONS + ERROR:
      return { ...state, listOauthApplications: { loading: false, error } };

    case CLEAN_OAUTH_APPLICATIONS + SUCCESS:
      return {
        ...state,
        listOauthApplications: { loading: false },
        oauthApplications: [],
        pagination: null,
        ...action.payload
      };

    case GET_OAUTH_APPLICATION + START:
      return { ...state, getOauthApplication: { loading: true } };
    case GET_OAUTH_APPLICATION + SUCCESS:
      return { ...state, getOauthApplication: { loading: false }, oauthApplication: data.item };
    case GET_OAUTH_APPLICATION + ERROR:
      return { ...state, getOauthApplication: { loading: false, error } };

    case SAVE_OAUTH_APPLICATION + START:
      return { ...state, saveOauthApplication: { loading: true } };
    case SAVE_OAUTH_APPLICATION + SUCCESS:
      return { ...state, saveOauthApplication: { loading: false }, oauthApplication: data.item };
    case SAVE_OAUTH_APPLICATION + ERROR:
      return { ...state, saveOauthApplication: { loading: false, error } };

    case DELETE_OAUTH_APPLICATION + START:
      return { ...state, deleteOauthApplication: { loading: true } };
    case DELETE_OAUTH_APPLICATION + SUCCESS:
      return {
        ...state,
        deleteOauthApplication: { loading: false },
        oauthApplications: state.oauthApplications.filter((s) => s.id !== data.item.id)
      };
    case DELETE_OAUTH_APPLICATION + ERROR:
      return { ...state, deleteOauthApplication: { loading: false, error } };

    case SET_RELOAD_OAUTH_APPLICATIONS:
      return { ...state, reloadOauthApplications: action.payload.reload };

    default:
      return { ...state };
  }
}
